import ArticleHeader from '../cms-components/blackrock/advisor-center/article-header/ArticleHeader';

export const ArticleHeaderComponent = ArticleHeader;
